import React, { PropsWithChildren } from 'react';

import { ScreenProps as CommonScreenProps } from '@front/common/src/components/screen/types';

import Text from '../base-text/variants/text';
import { useIsDesktopOrTablet } from '../../styles/media-queries';
import { WithClassNameProps } from '../types';
import { ScreenTitle } from '../base-text/variants/title';

import { ScreenContainer } from './container/container';
import { ScreenHeader } from './header/header';
import { SubtitleContainer } from './subtitle-container/subtitle-container';

export type ScreenProps = CommonScreenProps &
  WithClassNameProps &
  PropsWithChildren<{
    isCenteredOnDesktop?: boolean;
  }>;

const Screen = ({ title, text, className, children, isCenteredOnDesktop, testID }: ScreenProps) => {
  const isDesktopOrTablet = useIsDesktopOrTablet();
  return (
    <ScreenContainer className={className} data-testid={testID}>
      {title || text ? (
        <ScreenHeader>
          {!!title && (
            <ScreenTitle centered={isCenteredOnDesktop && isDesktopOrTablet} htmlTag='h1'>
              {title}
            </ScreenTitle>
          )}
          {!!text && (
            <SubtitleContainer data-testid='subtitle'>
              <Text>{text}</Text>
            </SubtitleContainer>
          )}
        </ScreenHeader>
      ) : null}
      {children}
    </ScreenContainer>
  );
};

export default Screen;
